/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CompanyWebhookEventType {
  ShipmentBooked = "shipment_booked",
  ShipmentQuoted = "shipment_quoted",
  ShipmentInTransit = "shipment_in_transit",
  ShipmentDelivered = "shipment_delivered",
  DraftCreated = "draft_created",
  ShipmentCancelled = "shipment_cancelled",
  ShipmentOnHold = "shipment_on_hold",
  DocumentUploaded = "document_uploaded",
  InvoicesUpdated = "invoices_updated",
  TrackingLineAdded = "tracking_line_added",
}

export function instanceOfCompanyWebhookEventType(value: any): boolean {
  for (const key in CompanyWebhookEventType) {
    if (Object.prototype.hasOwnProperty.call(CompanyWebhookEventType, key)) {
      if (
        CompanyWebhookEventType[key as keyof typeof CompanyWebhookEventType] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CompanyWebhookEventTypeFromJSON(
  json: any,
): CompanyWebhookEventType {
  return CompanyWebhookEventTypeFromJSONTyped(json, false);
}

export function CompanyWebhookEventTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyWebhookEventType {
  return json as CompanyWebhookEventType;
}

export function CompanyWebhookEventTypeToJSON(
  value?: CompanyWebhookEventType | null,
): any {
  return value as any;
}

export function CompanyWebhookEventTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CompanyWebhookEventType {
  return value as CompanyWebhookEventType;
}
